import '../../styles.scss';
import { Button } from '~/components';
import MessagesButton from './MessagesButton';
import { useProjectContext } from '~/hooks';
import useArchiveToastCheck from '~/hooks/archive/useArchiveToastCheck';

interface ActionsButtonProps {
  investorId: string;
  awaitingBid: boolean;
  setModalType: (type: 'ACCEPT_BID' | 'DECLINE_BID' | null) => void;
}

const ActionsButton = ({ 
  investorId, 
  awaitingBid, 
  setModalType,
} : ActionsButtonProps) => {
  const { project } = useProjectContext();
  
  const handleClick = useArchiveToastCheck(() => setModalType('ACCEPT_BID'));

  return (
    <>
      {awaitingBid ? (
        <Button>
          <MessagesButton
            project={project}
            investorId={investorId}
            awaitingBid={awaitingBid}
          />
        </Button>
      ) : (
        <Button onClick={() => handleClick()}>
          Accept bid
        </Button>
      )}
    </>
  );
};

export default ActionsButton;